export const ProductFlagType = {
    POPULAR: 'popular',
    HIDDEN: 'hidden',
    OUT_OF_STOCK: 'out-of-stock',
    NEW: 'new',
} as const;

export type ProductFlagType = typeof ProductFlagType[keyof typeof ProductFlagType];

